/**
 * Auto-Scroll Utilities
 *
 * Smooth scroll functionality with 300ms delay for DOM rendering.
 * Guides non-technical users through workflow steps.
 *
 * CRITICAL CONSTRAINTS:
 * - TypeScript strict mode (NO 'any' types)
 * - 300ms delay ensures DOM rendering
 * - Smooth scroll behavior
 */

/**
 * Scroll to element by ID with delay for DOM rendering
 *
 * @param elementId - ID of target element
 * @param delay - Delay in milliseconds (default: 300ms)
 */
export function scrollToElement(elementId: string, delay: number = 300): void {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } else {
      console.warn(`Element with ID "${elementId}" not found for auto-scroll`);
    }
  }, delay);
}

/**
 * Scroll to element with querySelector support
 *
 * @param selector - CSS selector for target element
 * @param delay - Delay in milliseconds (default: 300ms)
 */
export function scrollToSelector(selector: string, delay: number = 300): void {
  setTimeout(() => {
    const element = document.querySelector(selector);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } else {
      console.warn(`Element with selector "${selector}" not found for auto-scroll`);
    }
  }, delay);
}

/**
 * Scroll to top of page smoothly
 */
export function scrollToTop(): void {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
